module.exports = window["wpsl"];